"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.number.constructor");
require("quill/dist/quill.snow.css");
require("highlight.js/styles/monokai-sublime.css");
var _src = require("vue-quill-editor/src");
var _quill = _interopRequireDefault(require("../../../public/lib/quill"));
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    quillEditor: _src.quillEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    hideTool: {
      type: Boolean,
      default: false
    },
    limitNumb: {
      type: Number,
      default: 2000
    },
    editorStyle: {
      type: Object,
      default: function _default() {
        return {
          minHeight: '60px',
          lineHeight: '20px',
          width: '344.7px'
        };
      }
    },
    disabledStyle: {
      type: Object,
      default: function _default() {
        return {
          background: "#f5f7fa",
          color: "#c0c4cc",
          cursor: "not-allowed",
          borderRadius: "4px",
          border: "1px solid #dcdfe6"
        };
      }
    }
  },
  data: function data() {
    return {
      content: this.value,
      quill: null,
      finalStyle: {},
      editorOption: {
        theme: "snow",
        placeholder: "",
        modules: {
          toolbar: null
        }
      }
    };
  },
  watch: {
    value: function value(newValue) {
      this.content = newValue;
    },
    content: function content(newContent) {
      this.$emit('input', newContent);
    }
  },
  created: function created() {
    this.finalStyle = this.disabled ? this.disabledStyle : this.editorStyle;
  },
  mounted: function mounted() {
    var quill = this.$refs.editor.quill;
    quill.on('text-change', this.onTextChange);
  },
  methods: {
    onTextChange: function onTextChange(delta, oldDelta, source) {
      if (source !== 'user') return;
      var editor = this.$refs.editor.quill;
      var text = editor.getText();
      var maxLength = this.limitNumb;
      function calculateByteLength(str) {
        var blob = new Blob([str], {
          type: 'text/plain',
          charset: 'utf-8'
        });
        return blob.size;
      }
      function truncateInput(value) {
        var truncatedValue = value;
        while (calculateByteLength(truncatedValue) > maxLength && truncatedValue.length > 0) {
          truncatedValue = truncatedValue.slice(0, -1);
        }
        return truncatedValue;
      }
      var newValue = truncateInput(text);
      editor.setText(newValue);

      // if (text.length > this.limitNumb) {
      //   editor.setText(text.slice(0, this.limitNumb));
      //   editor.setSelection(this.limitNumb, 0);
      // }

      this.highlightSpecialChars(this.$refs.editor.quill);
    },
    highlightSpecialChars: function highlightSpecialChars(editor) {
      var text = editor.getText();
      var textLength = text.length;
      var specialCharIndices = [];
      for (var i = 0; i < textLength; i++) {
        var charCode = text.charCodeAt(i);
        var unicode = "\\u" + charCode.toString(16).padStart(4, '0');
        var isSpecialUnicode = unicode.startsWith('\\') && unicode !== "\\u005c" && unicode !== "\\u00a0";
        var unLegal = unicode === "\\u2001";
        var isIllegalAscii = charCode > 126 || charCode < 32 && ![10, 13, 9].includes(charCode);
        if (isSpecialUnicode && isIllegalAscii || unLegal) {
          console.log(unicode);
          specialCharIndices.push(i);
        }
      }
      editor.formatText(0, textLength, {
        'background': 'transparent'
      }, 'silent');
      specialCharIndices.forEach(function (index) {
        editor.formatText(index, 1, {
          'background': '#F27C49'
        }, 'silent');
      });
    }
  }
};